
import Input from "../../atoms/Input"
import Select from "../../atoms/Select"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import RcmpCheckBox from "../../atoms/Checkbox"
import { useEffect, useState } from "react"
import { Typography } from "@stardust-ds/react"
import RcmpTooltip from "../../atoms/Tooltip"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"
import { set } from "react-hook-form"

export default function RcmpTriggerEvent(props) {
    const { setValue, errors, getValues, watch, cUserTimezone, bDeadLineIsRequired, aBlocks, fnSetBIsDisabledButton, fnSetOblockSelected, cEventSelected, fnSetCEventSelected, fnGenerateTextEvent, bIsEditAutomation, bActiveAutomation } = props;
   
    const aEventOptions = [
        { value: "activity_created", label: intl.get("modal_new_automation.event_param.activity_created") },
        { value: "activity_moved", label: intl.get("modal_new_automation.event_param.activity_moved") },
        { value: "activity_finished", label: intl.get("modal_new_automation.event_param.activity_finished") },
        { value: "activity_deleted", label: intl.get("modal_new_automation.event_param.activity_deleted") },
        { value: "notification_expires_in", label: intl.get("modal_new_automation.event_param.activity_expires_in") },
        { value: "notification_expires_ago", label: intl.get("modal_new_automation.event_param.activity_expires_ago") }
    ]
    const oBlockOptions = aBlocks?.map((block) => ({
        label: block.opbl_cname,
        value: block.opbl_nid,
    }))
    const aBlocksOptions = [{ label: intl.get("modal_new_automation.whatever_block"), value: null }, ...oBlockOptions]
    const [bHasDeadLine, fnSetBHasDeadLine] = useState(!getValues("notDeadLine"))
    const [oBlocksOptions, fnSetOBlocksOptions] = useState(aBlocksOptions)
    const [bAllFilled, fnSetBAllFilled] = useState(true)
    const [nDeadLineDaysValue, fnSetDeadLineDaysValue] = useState(getValues("days") || 0)
    const aOptionTimeRangeDeadLine = [
        {
            label: intl.get("modal_new_form.hour"),
            value: "hour",
        },
        {
            label: intl.get("modal_new_form.day"),
            value: "day",
        },
        {
            label: intl.get("modal_new_form.week"),
            value: "week",
        },
        {
            label: intl.get("modal_new_form.month"),
            value: "month",
        },

    ]

    function fnOnChangeDeadLineDaysValue(e) {
        if (e.target.value === "" || Number(e.target.value) === (0 - 1)) {
            setValue("days", 0)
            fnSetDeadLineDaysValue("")
            return
        }
        if (Number(e.target.value) < 0) {
            return
        }
        if (Number(e.target.value) <= 999) {
            setValue("days", Number(e.target.value))
            fnSetDeadLineDaysValue(Number(e.target.value))
            return
        }
        return
    }

    useEffect(() => {

        if (!getValues("triggerType") || !getValues("blockId") || !getValues("blockId")?.value || !getValues("observedBlockId") || (getValues("triggerType")?.value === "activity_moved" && !getValues("fromBlockId"))) {
            fnSetBIsDisabledButton(true)
            return
        }
        fnSetBIsDisabledButton(false)
    },
        [watch("triggerType"), watch("blockId"), watch("fromBlockId"), watch("observedBlockId")])

    function fnHandleDeadLine(e) {
        fnSetBHasDeadLine(!e.target.checked)
        setValue("notDeadLine", e.target.checked)
    }
    function fnSelectDeadLineRange(e) {
        if (!e) {
            fnSetBAllFilled(false)
            setValue("deadLineRange", undefined)
            return
        }
        fnSetBAllFilled(true)
        setValue("deadLineRange", e)
    }

    function fnHandleKeyPress(e) {
        const regex = /^\d+$/

        if (!regex.test(e.key)) {
            e.preventDefault()
        }
    }

    function fnHandleSelect(e, field) {
        if (!e) {
            setValue(field, undefined)
            fnSetBIsDisabledButton(true)
            return
        }
        field === "triggerType" && fnSetCEventSelected((prev) => {
            if (prev === e.value) {
                return prev
            }
            if(prev === "activity_moved" && e?.value !== "activity_moved" && (getValues("blockId")?.value === null || getValues("fromBlockId")?.value === null)){
                setValue("blockId", undefined)
                setValue("fromBlockId", undefined)
            }
            return e?.value
        })

        if(field === "triggerType"){
            if(e.value === "activity_moved"){
                setValue("fromBlockId", getValues("blockId"))
                
            }
            setValue("triggerType", e)
            // setValue("automationType", e)
        }
        fnSetBIsDisabledButton(false)
        setValue(field, e)
  
    }
    return (
        <div className={styles.eventTriggerContainer}>
            <div>
                <div className={styles.triggerArea}>
                    <Select onSelect={(e) => fnHandleSelect(e, "triggerType")} options={aEventOptions} label={`${intl.get("modal_new_automation.when_a")} *`} defaultValue={getValues("triggerType") || ""} disabled={bIsEditAutomation || bActiveAutomation} />
                    {["notification_expires_in", "notification_expires_ago"].includes(cEventSelected) && 
                    <div className={styles.numberField}>
                        <input type="number" className={styles.numberField} onChange={fnOnChangeDeadLineDaysValue} value={nDeadLineDaysValue} min="0" onKeyPress={fnHandleKeyPress} max={"999"} />
                        <Typography type="l3" color="#415364">{intl.get("modal_new_automation.days")}</Typography>
                    </div>}
                </div>
                {errors.triggerType && <RcmpFormErrorMessage>{errors.triggerType?.label?.message}</RcmpFormErrorMessage>}
            </div>
            <div>
                <Select 
                onSelect={(e) => fnHandleSelect(e, getValues("triggerType")?.value !== "activity_moved" ? "observedBlockId" : "fromBlockId")}
                options={getValues("triggerType")?.value !== "activity_moved" || getValues("observedBlockId")?.value === null ? oBlocksOptions.slice(1) : oBlocksOptions} label={getValues("triggerType")?.value !== "activity_moved" ? `${intl.get("modal_new_automation.in_block")} *` : `${intl.get("modal_new_automation.from_block")} *`} 
                defaultValue={getValues("triggerType")?.value !== "activity_moved" ? getValues("observedBlockId") || "" : getValues("fromBlockId") || ""} 
                />
                { getValues("triggerType")?.value === "activity_moved" && (errors.blockId || errors.observedBlockId) ? 
                <RcmpFormErrorMessage>{errors.blockId?.label?.message}</RcmpFormErrorMessage>
                 :  
                 <RcmpFormErrorMessage>{errors.observedBlockId?.label?.message}</RcmpFormErrorMessage>}
            </div>
            {getValues("triggerType")?.value === "activity_moved"&&
                <div>
                <Select onSelect={(e) => fnHandleSelect(e, "observedBlockId")} options={getValues("fromBlockId")?.value === null ? oBlocksOptions.slice(1) : oBlocksOptions} label={`${ intl.get("modal_new_automation.to_block")} *`} defaultValue={getValues("observedBlockId")} />
                {errors.observedBlockId && <RcmpFormErrorMessage>{errors.observedBlockId?.label?.message}</RcmpFormErrorMessage>}
            </div>
            }
             
                 <div>
                    <Select onSelect={(e) => fnHandleSelect(e, "blockId")} options={oBlocksOptions.slice(1)} label={intl.get("modal_new_automation.create_activity_on_block")} defaultValue={getValues("blockId") || ""} />
                    {errors.blockId && <RcmpFormErrorMessage>{errors.blockId?.label?.message}</RcmpFormErrorMessage>}
                </div>

            <div className={styles.footerEvent}>
                <div className={styles.footerTextInfoEvent}>
                    <p >{intl.get("modal_new_automation.deadline_execution")}</p>
                    <RcmpTooltip bOnHover={true}>
                        {intl.get("modal_new_automation.info_deadline")}
                    </RcmpTooltip>
                </div>
                <div className={styles.footerSettingEvent}>
                    <Input disabled={!bHasDeadLine} className={styles.deadlineNumberArea} type="number" min="1" max="999" onChange={(e) => setValue("deadLineValue", e)} defaultValue={getValues("deadLineValue") || 1} />
                    <Select disabled={!bHasDeadLine} className={styles.timeRangeSelect} width={"155px"} options={aOptionTimeRangeDeadLine} defaultValue={getValues("deadLineRange") || aOptionTimeRangeDeadLine[0]} onSelect={(e) => fnSelectDeadLineRange(e)} />
                </div>

                <div className={styles.checkboxAreaEvent}>
                    <RcmpCheckBox cLabel={intl.get("modal_new_automation.without_deadline")} checked={getValues("notDeadLine")} onChange={(e) => fnHandleDeadLine(e)} />
                </div>
            </div>

        </div>


    )
}